import React from 'react';
import { XDrawerBottom } from '../x/drawer-bottom/XDrawerBottom';
import { UiGrid } from '@open-stack/ui';
import { XText, XTextType } from '../x/text/XText';
import { XCard } from '../x/card/XCard';
import { Environment } from '../../environment';
import { XButton } from '@orderx/lab/ui';

export class ErrorBoundary extends React.PureComponent<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            error: '',
        };
    }

    async componentDidCatch(error, errorInfo) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;

        if (error) {
            const message = error?.toString?.() || '';

            return (
                <XDrawerBottom onClose={() => {}}>
                    <XCard>
                        <UiGrid padding={2}>
                            <XText type={XTextType.TITLE_LARGE}>Oh no!</XText>

                            <XText>The app has encountered slight turbulence and thus needs to be restarted</XText>

                            {message && <XText>{message}</XText>}

                            <XText>Version: {Environment.APP_VERSION}</XText>

                            <XButton onClick={() => (window.location.href = '/')}>Restart</XButton>
                        </UiGrid>
                    </XCard>
                </XDrawerBottom>
            );
        } else {
            return this.props.children;
        }
    }
}
